import { render, staticRenderFns } from "./objectif-block-edit.vue?vue&type=template&id=55f984f1&"
import script from "./objectif-block-edit.vue?vue&type=script&lang=js&"
export * from "./objectif-block-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports